import React, { useState, useEffect, useContext } from 'react';
import Context from "../../context/context";


const BookingLink = props => {

  const { hash, url} = props;
  const {activeFilters} = useContext(Context);

  const handleSideBarOpen = (hash) => {
    fetch(base_url + 'ajax/booking_sidebar/' + hash + '/')
      .then(res => res.json())
      .then(
        (response) => {
          if (response.sidebar) {
            let gdEventInfo = document.getElementById('event-sidebar');
            let gdEventInfoBg = document.getElementById('event-sidebar-bg');

            gdEventInfo.innerHTML = response.sidebar;
            gdEventInfo.classList.add('active');
            gdEventInfoBg.classList.add('active');

            let swiper = gdEventInfo.querySelector('.sidebar-dates');
            let swiper_times = gdEventInfo.querySelector('.sidebar-times');

            let next = gdEventInfo.querySelector('.swiper-next');
            let prev = gdEventInfo.querySelector('.swiper-prev');
            var date_swiper = new Swiper(swiper, {
              slidesPerView: 'auto',
              spaceBetween : 0,
              mousewheel: true,
              direction: 'vertical',
              slideToClickedSlide: false,
              freeMode: true,
              preventClicks :true,
              a11y: false,
              navigation: {
                nextEl: next,
                prevEl: prev,
              },
            });

            let next_time = gdEventInfo.querySelector('.swiper-next-times');
            let prev_time = gdEventInfo.querySelector('.swiper-prev-times');
            var time_swiper = new Swiper(swiper_times, {
              slidesPerView: 'auto',
              spaceBetween : 0,
              mousewheel: true,
              direction: 'vertical',
              slideToClickedSlide: false,
              freeMode: true,
              preventClicks :true,
              a11y: false,
              navigation: {
                nextEl: next_time,
                prevEl: prev_time,
              },
            });
          } else {

          }
        }
      )
  }


  if (hash.length){
    return (

      <button className="button button-black" onClick={() => handleSideBarOpen(hash) }>
        Find and book tickets
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">

          <path class="fill-bg"  d="M0.300781 0H12.3008V12H0.300781V0Z" fill="black"/>
          <path class="fill" d="M0.300781 0V-1H-0.699219V0H0.300781ZM12.3008 0H13.3008V-1H12.3008V0ZM12.3008 12V13H13.3008V12H12.3008ZM0.300781 12H-0.699219V13H0.300781V12ZM0.300781 1H12.3008V-1H0.300781V1ZM11.3008 0V12H13.3008V0H11.3008ZM12.3008 11H0.300781V13H12.3008V11ZM1.30078 12V0H-0.699219V12H1.30078Z" fill="black" />
          <path class="stroke" d="M4.72882 3.17157L7.55724 6L4.72882 8.82843" stroke="white" stroke-width="1.5"/>
          </svg>
      </button>
    )
  } else {
    return (

      <a href={url} className="button button-black" >
        Find and book tickets
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">

          <path class="fill-bg"  d="M0.300781 0H12.3008V12H0.300781V0Z" fill="black"/>
          <path class="fill" d="M0.300781 0V-1H-0.699219V0H0.300781ZM12.3008 0H13.3008V-1H12.3008V0ZM12.3008 12V13H13.3008V12H12.3008ZM0.300781 12H-0.699219V13H0.300781V12ZM0.300781 1H12.3008V-1H0.300781V1ZM11.3008 0V12H13.3008V0H11.3008ZM12.3008 11H0.300781V13H12.3008V11ZM1.30078 12V0H-0.699219V12H1.30078Z" fill="black" />
          <path class="stroke" d="M4.72882 3.17157L7.55724 6L4.72882 8.82843" stroke="white" stroke-width="1.5"/>
          </svg>
      </a>
    )
  }






}

export default BookingLink;
